import AssociateDetailsModalSection from '../components/AssociatesComps/AssociateDetailsModalSection';
import AssociateMutationModals from '../components/AssociatesComps/AssociateMutationModals';
import ShowAllAssociates from '../components/AssociatesComps/ShowAllAssociates';
import PageTitle from '../components/CommonComps/Titles/PageTitle';
import AssociateProvider from '../contexts/AssociateProvider';
import MutationModalProvider from '../contexts/MutationModalProvider';

const Associates = () => {
  // rendering users page component here here
  return (
    <>
      <PageTitle title='Users' />

      <MutationModalProvider>
        <AssociateProvider>
          <ShowAllAssociates />
          <AssociateDetailsModalSection />
        </AssociateProvider>
        <AssociateMutationModals />
      </MutationModalProvider>
    </>
  );
};

export default Associates;
